import React, {FC, useState} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Colors, Text} from '@optimaxdev/design-system';

import {CloudinaryImage} from 'components/cloudinaryImage/cloudinaryImage';
import {DetailToggle} from 'components/success/detailToggle/detailToggle';
import {TYP_ORDER_CONFIRMATION} from 'constants/analytics/events/typ';
import {getFeatureAwareImage} from 'desktop/utils/lensTintsEg/lensTintsEg';
import {OrderDetailsItemsType} from 'types/orderDetailsTypes';

import {AttentionMessage} from './attentionMessage/attentionMessage';
import {GlassesItemDetails} from './glassesItemDetails/glassesItemDetails';

import s from './glassesItem.scss';

export type PropsType = {
    item: OrderDetailsItemsType;
    hasClickedSeeDetailRef: React.MutableRefObject<boolean>;
};

/**
 * Glasses item for TYP
 */
export const GlassesItem: FC<PropsType> = ({hasClickedSeeDetailRef, item}) => {
    const [isOpened, setIsOpened] = useState(false);

    const handleToggle = () => {
        hasClickedSeeDetailRef.current = true;
        sendDesktopAnalyticsEvent(
            TYP_ORDER_CONFIRMATION,
            {
                label: 'See Details',
            },
            true,
        );
        setIsOpened(v => !v);
    };

    return (
        <div>
            <div className={s.buttonWrapper}>
                <div className={s.header}>
                    <div className={s.imageWrapper}>
                        <CloudinaryImage
                            src={getFeatureAwareImage(
                                item.product,
                                item.product.image,
                                item.options,
                            )}
                            alt={item.name}
                            className={s.img}
                            width="100%"
                        />
                    </div>

                    <div>
                        <Text
                            as="p"
                            color={Colors.blueCharcoal}
                            lineHeight="24px"
                            margin="0 0 6px"
                            size="16px"
                            bold
                        >
                            {item.windowName}
                        </Text>

                        {item.isPrescriptionNeeded && <AttentionMessage />}
                        <DetailToggle isOpened={isOpened} toggleOpen={handleToggle} />
                    </div>
                </div>
            </div>
            <GlassesItemDetails isOpened={isOpened} item={item} />
        </div>
    );
};
